import { NgModule } from '@angular/core';
import { SharedModule } from './shared/shared.module';

import { MaterialModule } from './material.module';

import { appuser } from './users/appuser.component';
import { pdfViewerDialogComponent } from './pdfviewer/pdfViewer.dialog';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { imageViewerDialogComponent } from './imageViewer/ImageView.component';
import { PinchZoomModule } from 'ngx-pinch-zoom';

import { AddAEntityOperationDialog } from './application-management/manageEntityAndOperation/add-entity-operation-dialog.component';
import { exportexcelservice } from './exportToExcelService/exportexcelservice.service';

import { NgxMaskModule, IConfig } from "ngx-mask";
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [
    appuser,
    pdfViewerDialogComponent,
    imageViewerDialogComponent,
    AddAEntityOperationDialog,
  ],
  imports: [
    SharedModule,
    MaterialModule,
    PinchZoomModule,
    CommonModule,
    PdfViewerModule,
    NgxMaskModule.forRoot(maskConfig),
  ],
  entryComponents: [
    pdfViewerDialogComponent,
    imageViewerDialogComponent,
    AddAEntityOperationDialog,
  ],
  providers: [exportexcelservice],
})
export class ComponentsModule {}
